module.exports = __webpack_public_path__ + "static/media/pick3-logo-animated-header.fe95bdaa.png";